<template>
  <div class="octobus__columns is-mobile is-vcentered">
    <div class="octobus__column">
      <div class="passenger-nobus is-hidden-touch">
        <h2 class="is-size-4">{{route}}</h2>
        <p class="has-text-weight-semibold">{{$t('nobus.noplace')}}</p>
        <p>{{$t('nobus.info')}}</p>
      </div>
      <div class="passenger-nobus is-hidden-desktop">
        <p class="has-text-weight-semibold">{{route}}</p>
        <p>{{$t('nobus.free')}}</p>
      </div>
    </div>
    <div class="octobus__column is-hidden-tablet is-narrow-touch">
      <Price :price="price" />
    </div>
  </div>
</template>

<script>
import Price from './Price';

export default {
  name: 'Nobus',
  components: {
    Price,
  },
  props: {
    places: {
      type: Array,
    },
    raceId: {
      type: String,
      required: true,
    },
    departure: {
      type: String,
      required: true,
    },
    arrived: {
      type: String,
      required: true,
    },
    passenger: {
      type: Number,
      required: true,
    },
    price: {
      type: Object,
      required: true,
    },
  },
  computed: {
    route() {
      return `${this.departure} - ${this.arrived}`;
    },
  },
  created() {
    this.$emit('selectedPlace', this.places[0], this.raceId);
  },
};
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Passenger/Nobus.vue